import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { X, Plus, Minus, Trash2, ShoppingBag } from "lucide-react";
import { useCart } from "../context/CartContext";
import { eur, waLink } from "../config";
import { WhatsAppIcon } from "./WhatsAppButton";

export const CartDrawer = () => {
  const { open, setOpen, items, updateQty, removeItem, subtotal } = useCart();
  const navigate = useNavigate();

  const waOrder = () => {
    const lines = items.map((i) => `• ${i.name}${i.size ? ` (${i.size})` : ""} x${i.quantity} — ${eur(i.price * i.quantity)}`).join("\n");
    return waLink(`Bonjour La Boutique d'Esther ! Je souhaite commander :\n${lines}\n\nTotal : ${eur(subtotal)}`);
  };

  return (
    <div className={`fixed inset-0 z-[70] ${open ? "" : "pointer-events-none"}`} data-testid="cart-drawer">
      <div className={`absolute inset-0 bg-black/50 backdrop-blur-sm transition-opacity duration-300 ${open ? "opacity-100" : "opacity-0"}`} onClick={() => setOpen(false)} />
      <div className={`absolute right-0 top-0 h-full w-full max-w-md bg-creme flex flex-col shadow-2xl transition-transform duration-300 ${open ? "translate-x-0" : "translate-x-full"}`}>
        <div className="flex items-center justify-between px-6 py-5 border-b border-dore/20">
          <h3 className="font-display text-xl text-encre">Mon Panier</h3>
          <button onClick={() => setOpen(false)} data-testid="cart-close" aria-label="Fermer"><X size={22} /></button>
        </div>

        {items.length === 0 ? (
          <div className="flex-1 flex flex-col items-center justify-center text-center px-6 gap-4">
            <ShoppingBag size={44} className="text-dore/40" />
            <p className="text-ardoise">Votre panier est vide</p>
            <button onClick={() => { setOpen(false); navigate("/boutique"); }} className="bg-noir text-white px-6 py-3 text-xs uppercase tracking-widest hover:bg-ardoise transition-colors">Découvrir la boutique</button>
          </div>
        ) : (
          <>
            <div className="bg-rose/40 text-encre text-center text-xs py-2.5 px-4" data-testid="shipping-info-note">Livraison en Guadeloupe · frais calculés selon le poids au paiement</div>
            <div className="flex-1 overflow-y-auto px-6 py-4 space-y-5 no-scrollbar">
              {items.map((i) => (
                <div key={i.key} className="flex gap-4" data-testid="cart-item">
                  <img src={i.image} alt={i.name} className="w-20 h-24 object-cover" />
                  <div className="flex-1">
                    <p className="text-sm font-medium text-encre leading-tight">{i.name}</p>
                    <p className="text-xs text-ardoise/70 mt-0.5">{[i.size, i.color].filter(Boolean).join(" · ")}</p>
                    <p className="text-sm text-dore font-medium mt-1">{eur(i.price)}</p>
                    <div className="flex items-center gap-3 mt-2">
                      <div className="flex items-center border border-dore/30">
                        <button onClick={() => updateQty(i.key, i.quantity - 1)} className="p-1.5 hover:text-dore" data-testid="qty-minus"><Minus size={13} /></button>
                        <span className="px-2 text-sm w-7 text-center">{i.quantity}</span>
                        <button onClick={() => updateQty(i.key, i.quantity + 1)} className="p-1.5 hover:text-dore" data-testid="qty-plus"><Plus size={13} /></button>
                      </div>
                      <button onClick={() => removeItem(i.key)} className="text-ardoise/50 hover:text-red-500 transition-colors" data-testid="cart-remove"><Trash2 size={16} /></button>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="border-t border-dore/20 px-6 py-5 space-y-3">
              <div className="flex justify-between text-sm">
                <span className="text-ardoise">Sous-total</span>
                <span className="font-display text-lg text-encre" data-testid="cart-subtotal">{eur(subtotal)}</span>
              </div>
              <p className="text-[11px] text-ardoise/60 -mt-1">Frais de livraison calculés au paiement selon le poids.</p>
              <button onClick={() => { setOpen(false); navigate("/commande"); }} className="w-full bg-noir text-white py-3.5 text-xs uppercase tracking-widest font-semibold hover:bg-ardoise transition-colors" data-testid="checkout-btn">Passer la commande</button>
              <a href={waOrder()} target="_blank" rel="noreferrer" className="w-full flex items-center justify-center gap-2 bg-whatsapp text-white py-3.5 text-xs uppercase tracking-widest font-semibold hover:brightness-95 transition-all" data-testid="cart-whatsapp"><WhatsAppIcon size={16} /> Commander sur WhatsApp</a>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default CartDrawer;
